export default "__VITE_ASSET__CqTHTFw6__"